<template>
  <div :class="$style.topbar">
    <div class="mr-4">
<!--      <cui-issues-history />-->

    </div>
    <div class="mr-4">
<!--      <cui-project-management />-->
    </div>
    <div class="mr-auto">
<!--      <cui-live-search />-->
    </div>
<!--    <a-->
<!--      href="https://themeforest.net/item/clean-ui-react-admin-template/21938700"-->
<!--      target="_blank"-->
<!--      rel="noopener noreferrer"-->
<!--      class="mr-4 d-none d-sm-inline"-->
<!--    >-->

 <img src="resources/images/unimed.png" alt="unimed" height="42" width="122">

<!--    </a>-->
    <div class="mr-4">
<!--      <cui-bitcoin-price />-->
    </div>
    <div class="mr-4">
<!--      <cui-language-selector />-->
    </div>
    <div class="mr-4">
<!--      <cui-home-menu />-->
    </div>
    <cui-profile-menu />
  </div>
</template>

<script>
import CuiProfileMenu from '@/components/LayoutComponents/Topbar/ProfileMenu'

export default {
  components: {
    CuiProfileMenu,
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
